import qs from 'qs'
export const stringify = (option) => {
  return '?' + qs.stringify(option)
}
export const urlStringify = option => {
  return '?' + qs.stringify(option)
}
export const downloadBlobFile = (res) => {
  const fileName = res.headers['content-disposition']
    .split('filename')[1]
    .slice(1)
  const blob = new Blob([res.data], { type: res.headers['content-type'] })
  if (window.navigator.msSaveBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileName)
    return false
  }
  const a = document.createElement('a')
  document.body.appendChild(a)
  a.download = fileName
  a.target = '_blank'
  a.href = URL.createObjectURL(blob)
  a.click()
  document.body.removeChild(a)
}

export const downloadFile = (data, fileName, isBlob) => {
  const href = isBlob
    ? URL.createObjectURL(
      new Blob([data], {
        type: 'application/octet-stream;charset=UTF-8'
      })
    )
    : data
  const a = document.createElement('a')
  a.download = fileName
  a.target = '_blank'
  a.href = href
  a.click()
  document.body.removeChild(a)
}
function S4() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}
export const guid = (isSplit = true) => {
  const split = isSplit ? '-' : ''
  return (
    S4() +
    S4() +
    split +
    S4() +
    split +
    S4() +
    split +
    S4() +
    split +
    S4() +
    S4() +
    S4()
  )
}

export const ContentMode = [
  { label: '长图模式', value: 0 },
  { label: '外链模式', value: 1 },
  { label: '服务模式', value: 50 },
  { label: '资讯模式', value: 51 },
  { label: '园区模式', value: 52 }
]

export const UseStatus = [
  { label: '已领取', value: 2 },
  { label: '已使用', value: 3 },
  { label: '已过期', value: 8 },
  { label: '已作废', value: 9 }
]

export const voucherIsOpen = [
  { label: '已关闭', value: 0, action: '关闭' },
  { label: '已上架', value: 1, action: '上架' },
  { label: '未上架', value: 2, action: '下架' }
]
export const voucherOnGoing = [
  { label: '时间未到', value: 0 },
  { label: '时间内', value: 1 },
  { label: '时间已过', value: -1 }
]
